module.exports = __webpack_public_path__ + "bg-triple3.jpg";